
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/candidate-faqs",
      function () {
        return require("private-next-pages/about-us/candidate-faqs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/candidate-faqs"])
      });
    }
  